var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment"},[(_vm.card)?_c('div',{staticClass:"card"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }